import { FaAmazon /* , FaTicketSimple */ } from 'react-icons/fa6';
// Live section: import { FaAmazon, FaTicketSimple } from 'react-icons/fa6';
import { SiApplemusic, SiSoundcloud, SiSpotify, SiYoutube } from 'react-icons/si';
import './App.css';

/**
 * Replace href values with your real URLs.
 */
/* Live section — restore with JSX block below, SmartLinkRow, ticket icon, FaTicketSimple import
const LIVE_SECTION = {
  heading: 'aidn.: LIVE IN TORONTO',
  coverSrc: `${process.env.PUBLIC_URL}/aidn poster with skrta.png`,
  links: [
    {
      id: 'tickets-may16',
      label: 'TICKETS ON SALE NOW',
      href: 'https://admitone.com/events/toronto/community/music/fun-extension-presents-renaissance-vol-1/MZ05KA',
      icon: 'ticket',
    },
  ],
};
*/

const KPOP_STREAMING = {
  title: 'kpop 3',
  subtitle: 'Choose music service',
  coverSrc: `${process.env.PUBLIC_URL}/KPOP3.png`,
  links: [
    {
      id: 'spotify',
      name: 'Spotify',
      href: 'https://open.spotify.com/track/4JmJTPmljigNxDMJ7vIaV5?si=5d0c89863b9c45d3',
      icon: 'spotify',
      rowClass: 'streaming-popup__row--spotify',
    },
    {
      id: 'apple',
      name: 'Apple Music',
      href: 'https://music.apple.com/ca/album/kpop-3-single/6817270388',
      icon: 'apple',
      rowClass: 'streaming-popup__row--apple',
    },
    {
      id: 'youtube',
      name: 'YouTube Music',
      href: 'https://music.youtube.com/playlist?list=OLAK5uy_luVQO1rW1FvHELW0IveUDnsmu8Ww4p4dQ&si=pDnIEFiAtWXwo3Qo',
      icon: 'youtube',
      rowClass: 'streaming-popup__row--youtube',
    },
    {
      id: 'soundcloud',
      name: 'SoundCloud',
      href: 'https://soundcloud.com/wesforfun/kpop-3',
      icon: 'soundcloud',
      rowClass: 'streaming-popup__row--soundcloud',
    },
    {
      id: 'amazon-music',
      name: 'Amazon Music',
      href: 'https://amazon.com/music/player/albums/B0HLDFJDNS?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_i6YsK48qpw2eYYscvEAL16HWl',
      icon: 'amazonMusic',
      rowClass: 'streaming-popup__row--amazon',
    },
  ],
};

const ICON_COMPONENTS = {
  // ticket: FaTicketSimple, // live section
  spotify: SiSpotify,
  apple: SiApplemusic,
  youtube: SiYoutube,
  soundcloud: SiSoundcloud,
  amazonMusic: FaAmazon,
};

/* Live section — restore when LIVE_SECTION is back
function SmartLinkRow({ item }) {
  const Icon = ICON_COMPONENTS[item.icon];
  return (
    <li>
      <a
        className="smart-link"
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="smart-link__icon" aria-hidden>
          <Icon className="smart-link__icon-svg" />
        </span>
        <span className="smart-link__label">{item.label}</span>
        <span className="smart-link__spacer" aria-hidden />
      </a>
    </li>
  );
}
*/

function StreamingPlayRow({ item }) {
  const Icon = ICON_COMPONENTS[item.icon];
  return (
    <li>
      <a
        className={`streaming-popup__row ${item.rowClass}`}
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Play on ${item.name}`}
      >
        <span className="streaming-popup__row-icon" aria-hidden>
          <Icon className="streaming-popup__row-icon-svg" />
        </span>
        <span className="streaming-popup__row-name">{item.name}</span>
        <span className="streaming-popup__row-action">Play</span>
      </a>
    </li>
  );
}

function Kpop3Page() {
  return (
    <div className="App">
      <main className="smart-links">
        {/* Live section — restore LIVE_SECTION, SmartLinkRow, ticket icon, FaTicketSimple
        <section
          className="link-section link-section--live"
          aria-labelledby="live-show-heading"
        >
          <div className="streaming-popup streaming-popup--live">
            <div className="streaming-popup__cover-wrap">
              <img
                className="streaming-popup__cover"
                src={LIVE_SECTION.coverSrc}
                alt="Wesley Ou: Live in Toronto — AIDN concert poster"
                decoding="async"
              />
            </div>
            <h2 id="live-show-heading" className="streaming-popup__title">
              {LIVE_SECTION.heading}
            </h2>
            <ul className="streaming-popup__list streaming-popup__list--live">
              {LIVE_SECTION.links.map((item) => (
                <SmartLinkRow key={item.id} item={item} />
              ))}
            </ul>
          </div>
        </section>
        */}

        <section
          className="link-section link-section--streaming"
          aria-labelledby="kpop-title"
        >
          <div className="streaming-popup streaming-popup--kpop">
            <div className="streaming-popup__cover-wrap">
              <img
                className="streaming-popup__cover"
                src={KPOP_STREAMING.coverSrc}
                alt=""
                decoding="async"
              />
            </div>
            <h2 id="kpop-title" className="streaming-popup__title">
              {KPOP_STREAMING.title}
            </h2>
            <p className="streaming-popup__hint">{KPOP_STREAMING.subtitle}</p>
            <ul className="streaming-popup__list">
              {KPOP_STREAMING.links.map((item) => (
                <StreamingPlayRow key={item.id} item={item} />
              ))}
            </ul>
          </div>
        </section>

        <section
          className="link-section link-section--discord"
          aria-labelledby="discord-heading"
        >
          <div className="streaming-popup streaming-popup--discord">
            <div className="discord-widget">
              <iframe
                src="https://discord.com/widget?id=1483161772700602428&theme=dark"
                title="Discord server"
                width="350"
                height="500"
                allowTransparency
                frameBorder="0"
                sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
              />
            </div>
          </div>
        </section>
      </main>
      <footer className="site-footer">
        <p className="site-footer__text">© 2026 FUN EXTENSION RECORDS</p>
      </footer>
    </div>
  );
}

export default Kpop3Page;
